<!-- 积分明细 -->
<template>
<div>
    <el-table :data="tableData" 
        :row-class-name="tableRowClassName"
        :cell-class-name="tableCellStyle"
        class="custom-table"
        style="width: 100%" border>
        <el-table-column   
            v-for="(item, index) in dynamicHeaders"
            :key="index"
            :prop="item.prop"
            :label="item.label" 
            align="center">
        </el-table-column>
    </el-table>
</div>
</template>

<script>
export default {
    props: {
        pubId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tableData:[],
            tableHeaders: [
                {label: '排名', prop: 'rank'},                
                {label: '名称', prop: 'username'},
                {label: '积分', prop: 'score'},    
                {label: '角色', prop: 'rolename'},              
                {label: '手机号', prop: 'phone'},
            ],
            dynamicHeaders:[]
        }
    },
    created() {

    },
    mounted() {
        console.log('haha',this.pubId)
    },
    methods: {
        getQuery(){
            let params = {
                opcode: this.$code.SetGradeQuery,
                i_serial_mark: this.pubId
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){
                        this.tableData = result.map(item=>{                    
                            return{                            
                                rank: item['赛事角色']=== '赛事选手' ? item['名次']: '',
                                username: item['姓名'],
                                score: item['积分'],
                                phone: item['手机号'],    
                                rolename: item['赛事角色'], 
                            }
                        })    
                    this.isShow = true
                    // 获取所有唯一的字段名
                        const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));

                        this.dynamicHeaders = this.tableHeaders.filter(i=>fields.includes(i.prop))
                    }else{
                        this.$message.error('暂无成绩')
                    }                               
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        tableRowClassName({row, rowIndex}){
            // 选手以外的角色一种颜色
            if(row.rolename !== '赛事选手'){
                return 'green-row'
            }
        },
        tableCellStyle({row,column, rowIndex}){
            if(column.property === 'score'){
                 return 'red-row'
            }
        }
    }
}
</script>
<style lang='scss' scoped>
  @import '@/assets/css/style.scss';
.custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
.custom-table >>> .el-table{
    font-size: 20px;
}
.el-table >>> .green-row{
    background-color: #bbffbb
}
.el-table >>> .red-row{
    color: red;
    font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/components/gradeDetail.vue